import React from 'react';
const defaultValue = null;
export const ResidualContex = React.createContext(defaultValue);
export const VehicleContext = React.createContext(defaultValue);
